import React from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import MuiDialogTitle, { DialogTitleProps as MuiDialogTitleProps } from '@material-ui/core/DialogTitle';
import { Close as CloseIcon } from '@material-ui/icons';
import classnames from 'classnames';

import IconButton from './IconButton';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.custom.palette.colorSupportMidnight,
    },
    rootWithCloseButton: {
      '& > *': {
        marginRight: theme.spacing.unit * 4,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing.unit,
      top: 14,
      color: theme.palette.common.white,
    },
  });

export interface DialogTitleProps extends Omit<MuiDialogTitleProps, 'classes'>, WithStyles<typeof styles> {
  onClose?: () => void;
}

const DialogTitle: React.FC<DialogTitleProps> = ({ classes, children, onClose, ...rest }) => (
  <MuiDialogTitle
    classes={{
      root: classnames(classes.root, { [classes.rootWithCloseButton]: !!onClose }),
    }}
    {...rest}
  >
    {children}
    {onClose && (
      <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    )}
  </MuiDialogTitle>
);

export default withStyles(styles, { name: 'LumaDialogTitle' })(DialogTitle);
